// extracted by mini-css-extract-plugin
module.exports = {"SearchResults":"SearchResults_SearchResults__2-U0I","Header":"SearchResults_Header__1q3rr"};